export const defaultUserValues = {
  email: '',
  formName: '',
  nickname: '',
  password: '',
};

export const NAME_OF_TEMP_APP = 'newApp';
export const ERROR_ORIGIN = 'user creator';
